export const qpqHeaderIsBot = 'x-qpq-is-bot';
